module.exports = __webpack_public_path__ + "static/img/prepare_widget_2.146a22a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/prepare_widget_2.png
// module id = KbRU
// module chunks = 11